<template>
<div>
  <div v-if="$auth.ready()">
    <router-view></router-view>
  </div>

  <div v-if="!$auth.ready()">
    Loading ...
  </div>
  <loading :active.sync="isLoading" is-full-page></loading>
</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
export default {
  name: 'app',
  components: {
  Loading
  },
  data() {
  return {
    refCount: 0,
    isLoading: false
  }
},
watch: {
  '$route': {
    handler: (to, from) => {
      document.title = to.meta.title || 'SoamiBagh'
    },
    immediate: true
  }
},
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++
        this.isLoading = true
      } else if (this.refCount > 0) {
        this.refCount--
        this.isLoading = (this.refCount > 0)
      }
    }
  },
  created() {
    axios.interceptors.request.use((config) => {
      this.setLoading(true)
      return config
    }, (error) => {
      this.setLoading(false)
      return Promise.reject(error)
    })

    axios.interceptors.response.use((response) => {
      this.setLoading(false)
      return response
    }, (error) => {
      this.setLoading(false)
      return Promise.reject(error)
    })
  }

}
</script>

<style lang="scss">
// CoreUI Icons Set
@import '~@coreui/icons/css/coreui-icons.min.css';
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';
/* Import Flag Icons Set */
@import '~flag-icon-css/css/flag-icon.min.css';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import 'assets/scss/style';

@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
@import '../node_modules/vue-loading-overlay/dist/vue-loading.css';

</style>
